export default "__VITE_ASSET__0c6b176c__"